class ValidationUtility
{
    static IsEmailValid(email)
    {
        if(typeof email !== 'string')
        {
            return false;
        }
        
        if(email.count('@') !== 1)
        {
            return false;
        }

        let index = email.indexOf('@');

        if(index <= 0 || index >= email.length - 1)
        {
            return false;
        }

        if(email.lastIndexOf('.') < index)
        {
            return false;
        }

        return true;
    }

    static IsPhoneNumberValid(phoneNumber)
    {
        if(typeof phoneNumber !== 'string')
        {
            return false;
        }

        phoneNumber = phoneNumber.trim();

        let digitCount = phoneNumber.count(this.IsDigit);

        if(digitCount < 5 || digitCount > 18)
        {
            return false;
        }

        if(phoneNumber.count('+') > 1)
        {
            return false;
        }

        let allowedChars = [ '-', ' ', '(', ')', '+' ];

        if(phoneNumber.split("").some(ch => !this.IsDigit(ch) && !allowedChars.includes(ch)))
        {
            return false;
        }

        return true;
    }

    static IsDigit(ch)
    {
        return '0' <= ch && ch <= '9';
    }
}

export default ValidationUtility;